
import { Component, Vue } from "vue-property-decorator";
import { dataVisualizationModule } from "@/store";

@Component
export default class CurrentAgeCount extends Vue {
  // Use new getter with key-based data
  get chartData(): any[] {
    return dataVisualizationModule.getChartData("currentAgeCount");
  }

  get tableHeaders(): string[] {
    return this.chartData.length ? Object.keys(this.chartData[0]) : [];
  }

  async mounted() {
    try {
      await dataVisualizationModule.loadAll("currentAgeCount");
    } catch (e) {
      console.error("Failed to load chart data:", e);
    }
  }
}
